module.exports = __webpack_public_path__ + "img/logout.4a46d9fa.png";